import { EditableText, defineBlock } from "eddev/blocks"
import { useHydrating } from "eddev/routing"
import { useCategories, usePublications } from "@hooks/queries"
import { Fragment, useMemo } from "react"
import { Button } from "@components/atoms/Button"
import { VSpace } from "@components/layout/Spacer"
import { Col, Container, Grid } from "@components/layout/Grid"
import { PublicationGroupCard } from "@components/molecules/Cards"
import { useIsMobile } from "@hooks/useViewportDerived"

export const meta: BlockMeta = {
  title: "Publications list",
  category: "common",
  icon: "align-right",
  keywords: ["filter"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("publications/publications-list", (props) => {
  const publications = usePublications()
  const publicationList = useMemo(() => {
    if (publications.data?.documentPublications?.nodes) {
      return publications.data.documentPublications.nodes.filter((node) => node.documents!.nodes.length > 0)
    }
    return []
  }, [publications])
  const isMobile = useIsMobile()
  const hydrating = useHydrating()

  return (
    <Container className="py-5 lg:py-7">
      <Grid>
        {!isMobile && <Col initial={12} tablet={1} laptop={2} />}
        <Col initial={12} tablet={10} laptop={8}>
          <div className="flex flex-col gap-[calc(var(--spacing-4)*2)] md:[&_h2]:text-center">
            <EditableText as="h2" store="heading" placeholder="Enter heading..." />
            <EditableText as="p" store="content" placeholder="Enter content..." />
          </div>
        </Col>

        <Col initial={12}>
          <VSpace initial={10} />
        </Col>
      </Grid>

      <Grid className="gap-4">
        {!hydrating && publicationList.map((publication, i) => (
          <Col initial={12} key={i}>
            <PublicationGroupCard {...publication} />
          </Col>
        ))}
      </Grid>
    </Container>
  )
})
